
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import stores from '../../stores';
import routerBase from '@/helpers/routerBase';
import globalConfig from '@/helpers/globalConfig';
import { bus } from '@/helpers/functions';
import TheAdmin from '@/stores/TheLogedInAdmin';

@Component
export default class LoginItem extends Vue {
  username: string = '';
  password: string = '';
  rememberMe: boolean = false;
  session = stores.session;

  inDevelopment = globalConfig.env === 'development';

  redirectPath: string | null = null;

  errorMessage: string | null = null;

  admin = stores.admin;
  image = require('@/assets/images/profile-img.png');

  @Watch('admin.isLoggedInWithoutOTPVerification', {immediate: true})
  adminWatch() {
    this.redirect();
  }

  redirect() {

    if (stores.admin.hasToken) {
      bus().$emit('logged', 'User logged');
      this.$router.replace(this.redirectPath || '/dashboard');
    }
    if (stores.admin.isLoggedInWithoutOTPVerification) {
      this.$router.replace({ name : '2FA'});
      return
    }
  }

  async beforeCreate() {
    const currentProjectId = routerBase;
    await stores.master.getSpecificProjectInfo(currentProjectId)
      .then(
        (response: any) =>
        {
        //Validate.
          if ( !response )
          {
          //Undefined -> ignore.
            return;
          }

        //Was all ok?
          if (response.error) {
            this.$router.replace({name: '404', query: {error: `Project \"${this.session.projectId}\" does not exist`}});
          }
        }
      );
  }

  mounted() {
    Vue.prototype.WebsiteTitle.setModuleName('login');
    this.redirectPath = this.$route.query.redirect as string;
  }

  async onSubmit() {
    try {
      const loginResponse = await stores.admin.login(this.username, this.password, this.rememberMe);
      this.errorMessage = null;
      // Only complete login flow if token is set properly.
      if(stores.admin.hasToken)
      {
        bus().$emit('login');
      }
      this.redirect();
    } catch (error) {
      console.error(error);
      this.errorMessage = (error && error.message) || (error && error.data && error.data.message) || 'An unexpected error occurred.';
      throw error;
    }
  }


  defaultLogo(event?: any) {
    if (!event) {
      return require('../../../assets/nevron_logo.png');
    }
    event.target.src = require('../../../assets/nevron_logo.png');
  }

}
